import { Unit } from "uom";
/**
 * The unit for solid angle quantities ( <code>sr</code> ).
 * One steradian is the solid angle subtended at the center of a sphere by an area on the
 * surface of the sphere that is equal to the radius squared. The total solid angle of a sphere is 4*Pi steradians.
 */
export var Steradian = Unit.createBase("Steradian", "SolidAngle", "sr");
//# sourceMappingURL=solid-angle.js.map